<div class="dashboard-shell">
  <div class="dashboard-overlay" *ngIf="sidebarOpen" (click)="closeSidebar()"></div>

  <app-dashboard-sidebar
    [isAdmin]="isAdmin"
    [isStudentManager]="isStudentManager"
    [mobileOpen]="sidebarOpen"
    (logout)="logout()"
    (closeMobile)="closeSidebar()"
    (openMyAccounts)="openMyAccountsModal()"
    (openSupportContact)="openSupportContactModal()">
  </app-dashboard-sidebar>

  <div class="dashboard-main">
    <app-dashboard-topbar
      [searchKeyword]="searchKeyword"
      [userInitial]="userInitial"
      [fullName]="fullName"
      [loginName]="loginName"
      [showSearch]="!showChildRoute"
      (searchKeywordChange)="onSearchChange($event)"
      (toggleSidebar)="toggleSidebar()"
      (openThemeModal)="openThemeModal()"
      (logout)="logout()">
    </app-dashboard-topbar>

    <main class="dashboard-body" [class.dashboard-body--admin]="showChildRoute">
      <ng-container *ngIf="isHomePage">
        <section class="homepage-layout">
          <div class="homepage-layout__main">
            <app-welcome-banner
              [fullName]="fullName"
              [loginName]="loginName"
              [lastLoginTime]="lastLoginTime">
            </app-welcome-banner>

            <app-all-systems-section
              title="Danh sách hệ thống"
              [showInlineSearch]="false"
              [systems]="filteredSystemList"
              [selectedCategory]="selectedCategory"
              [categories]="systemCategories"
              [searchKeyword]="searchKeyword"
              [loading]="loading"
              (categoryChange)="onCategoryChange($event)"
              (searchKeywordChange)="onSearchChange($event)"
              (togglePin)="togglePin($event.systemId, $event.event)">
            </app-all-systems-section>
          </div>

          <aside class="homepage-layout__right">
            <app-notifications-slide></app-notifications-slide>
            <div class="support-contact-card">
              <h3 class="support-contact-card__title">
                <span class="support-contact-card__icon" nz-icon nzType="customer-service" nzTheme="outline"></span>
                {{ 'sidebar.supportContact' | translate }}
              </h3>
              <app-support-contact-panel></app-support-contact-panel>
            </div>
          </aside>
        </section>
      </ng-container>

      <ng-container *ngIf="isMySystemsPage">
        <app-all-systems-section
          title="Danh sách hệ thống"
          [systems]="filteredSystemList"
          [selectedCategory]="selectedCategory"
          [categories]="systemCategories"
          [searchKeyword]="searchKeyword"
          [loading]="loading"
          (categoryChange)="onCategoryChange($event)"
          (searchKeywordChange)="onSearchChange($event)"
          (togglePin)="togglePin($event.systemId, $event.event)">
        </app-all-systems-section>
      </ng-container>

      <router-outlet *ngIf="showChildRoute"></router-outlet>
    </main>

      <footer class="dashboard-footer">
        © {{ currentYear }} • Cổng xác thực tập trung • Cổng đăng nhập SSO
      </footer>
    </div>
</div>

<nz-modal
  [(nzVisible)]="showThemeModal"
  [nzTitle]="'dashboard.themeSelect' | translate"
  (nzOnCancel)="closeThemeModal()"
  [nzFooter]="null"
  nzCentered>
  <ng-container *nzModalContent>
    <div class="theme-options">
      <button
        type="button"
        class="theme-option theme-option--light"
        [class.theme-option--selected]="currentTheme === 'light'"
        (click)="setTheme('light')">
        <span nz-icon nzType="check-circle" *ngIf="currentTheme === 'light'"></span>
        <span nz-icon nzType="bulb" class="theme-option-icon"></span>
        <span>{{ 'dashboard.themeLight' | translate }}</span>
      </button>
      <button
        type="button"
        class="theme-option theme-option--dark"
        [class.theme-option--selected]="currentTheme === 'dark'"
        (click)="setTheme('dark')">
        <span nz-icon nzType="check-circle" *ngIf="currentTheme === 'dark'"></span>
        <span nz-icon nzType="bg-colors" class="theme-option-icon"></span>
        <span>{{ 'dashboard.themeDark' | translate }}</span>
      </button>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="showAddAppModal"
  [nzTitle]="'dashboard.addAppModalTitle' | translate"
  (nzOnCancel)="closeAddAppModal()"
  [nzFooter]="null"
  nzCentered>
  <ng-container *nzModalContent>
    <div class="add-app-list" *ngIf="unpinnedSystems.length > 0">
      <button
        type="button"
        class="add-app-item"
        *ngFor="let system of unpinnedSystems; trackBy: trackBySystemId"
        (click)="pinFromModal(system.id)">
        <span class="add-app-item__name">{{ system.name }}</span>
        <span nz-icon nzType="plus" nzTheme="outline"></span>
      </button>
    </div>
    <p class="add-app-empty" *ngIf="unpinnedSystems.length === 0">
      {{ 'dashboard.allAppAdded' | translate }}
    </p>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="showSupportContactModal"
  [nzTitle]="'sidebar.supportContact' | translate"
  (nzOnCancel)="closeSupportContactModal()"
  [nzFooter]="null"
  nzWrapClassName="support-contact-modal"
  nzCentered>
  <ng-container *nzModalContent>
    <app-support-contact-panel></app-support-contact-panel>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="showMyAccountsModal"
  [nzTitle]="'dashboard.myAccountsModalTitle' | translate"
  [nzWidth]="1100"
  (nzOnCancel)="closeMyAccountsModal()"
  [nzFooter]="null"
  nzWrapClassName="my-accounts-modal"
  nzCentered>
  <ng-container *nzModalContent>
    <p class="my-accounts-desc" *ngIf="loginName">
      {{ 'dashboard.ssoAccountLabel' | translate }} <strong>{{ loginName }}</strong>
    </p>
    <nz-spin [nzSpinning]="myAccountsLoading">
      <div class="my-accounts-table-wrap" *ngIf="!myAccountsLoading && myAccounts.length > 0">
        <table class="my-accounts-table">
          <thead>
            <tr>
              <th>{{ 'dashboard.colSystem' | translate }}</th>
              <th>{{ 'dashboard.colSystemAccount' | translate }}</th>
              <th>{{ 'dashboard.colPassword' | translate }}</th>
              <th>{{ 'dashboard.colDescription' | translate }}</th>
              <th>{{ 'dashboard.colUsageGuide' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of myAccounts; trackBy: trackByMyAccountId">
              <td>{{ row.projectName || row.projectClientId || '—' }}</td>
              <td>{{ row.systemLoginName || '—' }}</td>
              <td class="password-cell">
                <span *ngIf="isMyPasswordVisible(row)">{{ row.password || '—' }}</span>
                <span *ngIf="!isMyPasswordVisible(row)">••••••••</span>
                <button nz-button nzType="text" type="button" (click)="toggleMyPasswordVisibility(row)">
                  <span nz-icon [nzType]="isMyPasswordVisible(row) ? 'eye-invisible' : 'eye'" nzTheme="outline"></span>
                </button>
              </td>
              <td class="text-cell">
                <div class="text-cell__inner">
                  <ng-container *ngIf="row.accountDescription; else emptyAccountDesc">
                    <ng-container *ngFor="let token of parseTextWithLinks(row.accountDescription)">
                      <a *ngIf="token.isLink" [href]="token.href" target="_blank" rel="noopener noreferrer">{{ token.text }}</a>
                      <span *ngIf="!token.isLink">{{ token.text }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-template #emptyAccountDesc>—</ng-template>
                </div>
              </td>
              <td class="text-cell">
                <div class="text-cell__inner">
                  <ng-container *ngIf="row.usageGuide; else emptyUsageGuide">
                    <ng-container *ngFor="let token of parseTextWithLinks(row.usageGuide)">
                      <a *ngIf="token.isLink" [href]="token.href" target="_blank" rel="noopener noreferrer">{{ token.text }}</a>
                      <span *ngIf="!token.isLink">{{ token.text }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-template #emptyUsageGuide>—</ng-template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="my-accounts-empty" *ngIf="!myAccountsLoading && myAccounts.length === 0">
        {{ 'dashboard.noAssignedAccount' | translate }}
      </p>
    </nz-spin>
  </ng-container>
</nz-modal>
